// extracted by mini-css-extract-plugin
export default {"root":"UnitTable_root__A+ZLI","table":"UnitTable_table__Huvdv","message":"UnitTable_message__M3VKB"};